// extracted by mini-css-extract-plugin
export default {"page":"zZ-z","cartModal":"AZ-z","checkout":"BZ-z","placeholder":"CZ-z","account":"DZ-z"};